import React from 'react';

const RadioOption = ({id, name, icon, title, text, onChange}) => {
    return (
        <div className='radio-option'>
            <input type="radio" id={id} name={name} onChange={onChange} />
            <label htmlFor={id} className='radio-option-content flex flex-align-start'>
                <div className="icon">
                    {icon || ''}
                </div>
                <div className='radio-option-text'>
                    <h6 className="title">{title}</h6>
                    <p>{text}</p>
                </div>
            </label>
        </div>
    );
}

export default RadioOption;